export default __webpack_public_path__ + "assets/STROMMAST_LOWPOLY_SCALE_1_OHNE_NETZ_V17.usdz";